<mat-radio-button [value]="value" [checked]="selected">{{ label }}</mat-radio-button>
